import $ from 'domtastic'




/* BASE COMPONENT
---------------------------------------------------------------------------------------------------- */

export default class Base {

    constructor(namespace = 'base') {
        this.events = []
        this.namespace = namespace

        if (namespace !== '.global') {
            this.offCallback = [document, 'pageWillChange', this.off.bind(this)]
        }
    }




    /* Bind/Unbind all events in the stack.
    --------------------------------------------------------- */

    on() {
        const { passiveEvent, activeEvent } = APP.Browser
        const finalEvents = [...this.events, this.offCallback].filter(e => !!e)


        finalEvents.forEach((ev) => {
            const [$target, name, callback, isPassive] = ev
            const t = getTarget($target)

            let passivity = false
            if (typeof isPassive !== 'undefined') {
                passivity = (isPassive) ? passiveEvent : activeEvent
            }


            Array.from(t).forEach(($t) => { $t.addEventListener(name, callback, passivity) })
        })
    }


    off() {
        const finalEvents = [...this.events, this.offCallback].filter(e => !!e)

        finalEvents.forEach((ev) => {
            const [$target, name, callback] = ev
            const t = getTarget($target)

            Array.from(t).forEach(($t) => { $t.removeEventListener(name, callback) })
        })
    }




    /* Add an event to the stack.
    --------------------------------------------------------- */

    addListener(target, name, callback, isPassive) {
        if (!target || target.length === 0) return

        const types = name.split(' ')

        types.forEach((type) => {
            this.events.push([target, type, callback, isPassive])
        })
    }

    addListeners(...events) {
        events.forEach(([target, name, callback, isPassive]) => {
            this.addListener(target, name, callback, isPassive)
        })
    }




    /* Remove an event from the stack.
    --------------------------------------------------------- */

    removeListener(target, name) {
        const types = name.split(' ')

        types.forEach((type) => {
            const idx = this.events.findIndex(([t, n]) => t === target && n === type)

            if (idx === -1) return

            this.events.splice(idx, 1)
        })
    }




    /* Add an event to the stack and bind it.
    --------------------------------------------------------- */

    bindListener(target, name, callback, isPassive) {
        const t = getTarget(target)
        const types = name.split(' ')

        if (!t) return

        types.forEach((type) => {
            this.addListener(target, type, callback, isPassive)

            Array.from(t).forEach(($t) => { $t.addEventListener(type, callback, isPassive) })
        })
    }




    /* Remove an event from the stack and unbind it.
    --------------------------------------------------------- */

    unbindListener(target, name, callback) {
        if (!target) return

        const types = name.split(' ')

        types.forEach((type) => {
            const [$target] = this.events.find(([t, n]) => t === target && n === type)
            const t = getTarget($target)

            Array.from(t).forEach(($t) => { $t.removeEventListener(type, callback) })

            this.removeListener(target, name)
        })
    }

}




/* CONSTANTS & HELPERS
---------------------------------------------------------------------------------------------------- */

const getTarget = $target => (typeof $target[0] !== 'undefined' ? $target : [$target])

export const getUtils = () => {
    const $win = $(window)
    const $doc = $(document)
    const $body = $('body')

    return {
        $win,
        win: $win,
        $doc,
        doc: $doc,
        $body,
        body: $body,
    }
}

export const getRefs = ($el, name) => {
    const $e = ('find' in $el) ? $el : $($el)

    const selector = `js-${name}-`
    const refsObject = {}
    const $children = $e.find(`[class*="${selector}"]`)


    $children.forEach(($c) => {
        const refs = [...$c.classList].reduce((acc, c) => {
            if (c.indexOf(selector) === 0) {
                acc.push(c.replace(selector, ''))
            }

            return acc
        }, [])

        refs.forEach((r) => {
            if (!(r in refsObject)) {
                const $els = $e.find(`.${selector + r}`)
                refsObject[`$${r}`] = $els
                refsObject[r] = $els
            }
        })
    })


    return refsObject
}

